import { api } from "../../lib";

export interface Machine {
  id: string;
  name: string;
  categoryId: string | null;
  vendorId: string | null;
  connectionType: string | null;
  connectionConfig: any;
  isOnline: boolean;
  lastHeartbeat: string | null;
  retryAttempts: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  category?: { id: string; name: string } | null;
  vendor?: { id: string; name: string } | null;
}

export interface CreateMachineInput {
  name: string;
  category_id?: string;
  vendor_id?: string;
  connection_type?: string;
  connection_config?: any;
  retry_attempts?: number;
}

export interface UpdateMachineInput extends Partial<CreateMachineInput> {
  id: string;
}

export const machinesService = {
  getAll: async () => {
    return api.get<Machine[]>("/admin/machines");
  },

  getActive: async () => {
    return api.get<Machine[]>("/admin/machines", {
      params: { is_active: true },
    });
  },

  getOnline: async (vendorId?: string) => {
    return api.get<Machine[]>("/admin/machines/online", {
      params: { vendor_id: vendorId },
    });
  },

  getById: async (id: string) => {
    return api.get<Machine>(`/admin/machines/${id}`);
  },

  create: async (input: CreateMachineInput) => {
    return api.post<Machine>("/admin/machines", input);
  },

  update: async (input: UpdateMachineInput) => {
    const { id, ...updates } = input;
    return api.put<Machine>(`/admin/machines/${id}`, updates);
  },

  updateConnectionConfig: async (id: string, config: any) => {
    return api.put<Machine>(`/admin/machines/${id}/connection-config`, config);
  },

  updateHeartbeat: async (id: string) => {
    return api.post<Machine>(`/admin/machines/${id}/heartbeat`);
  },

  setOnlineStatus: async (id: string, isOnline: boolean) => {
    return api.put<Machine>(`/admin/machines/${id}/online-status`, {
      is_online: isOnline,
    });
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<Machine>(`/admin/machines/${id}`, { is_active: isActive });
  },
};
